import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ParticipantActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Web/Participant/ParticipantBrowser")
	}

	render() {
		return (
			<Activity 
				name="Participant"
				RenderedComponent={this.RenderedComponent}
                context="Participant"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ParticipantActivity)
